export default __webpack_public_path__ + "static/media/play_icon.2a533855.png";